import { useRef } from 'react';
import { avoidBreakAfter, avoidBreakInside } from '@provider/print';
import { useKatex } from '@utils/react';
import { AudioContent } from './atom.audio.js';
import { ImageContent } from './atom.image.js';
import { TextContent } from './atom.text.js';
import { useStickyHeader } from './hook.sticky-header.js';
import { contentWrapper, content } from './molecule.content.style.js';
import { jsx } from 'react/jsx-runtime';

function DropzoneContent(props) {
  const contentRef = useRef(null);
  useStickyHeader(props.wrapperRef, contentRef, !props.standaloneImageDropzone && props.state === "interactive");
  useKatex(contentRef);
  const content$1 = (() => {
    switch (props.content.type) {
      case "Audio":
        return /*#__PURE__*/jsx(AudioContent, {
          src: props.content.src,
          title: props.content.title
        });
      case "Image":
        return /*#__PURE__*/jsx(ImageContent, {
          title: props.content.title,
          src: props.content.src,
          alt: props.content.altText ?? "",
          audioSrc: props.content.audioSrc
        });
      case "Text":
        return /*#__PURE__*/jsx(TextContent, {
          text: props.content.text
        });
    }
  })();
  return /*#__PURE__*/jsx("div", {
    className: contentWrapper,
    "data-theme": props.theme,
    "data-interactive": props.state === "interactive",
    "data-standalone-image": props.standaloneImageDropzone,
    "data-allow-multiple": props.allowMultipleTiles,
    ...avoidBreakInside({
      extend: {
        top: 10
      }
    }),
    ...(props.content.type !== "Image" ? avoidBreakAfter() : undefined),
    children: /*#__PURE__*/jsx("div", {
      className: content,
      ref: contentRef,
      children: content$1
    })
  });
}

export { DropzoneContent };
//# sourceMappingURL=molecule.content.js.map
